"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAffiliateCookie = exports.AFFILIATE_COOKIE_NAME = exports.basketCookieHeader = exports.removeBasketCookie = exports.getBasketCookie = exports.setBasketCookie = exports.removeOrderReferenceCookie = exports.getOrderReferenceCookie = exports.setOrderReferenceCookie = exports.checkoutCookieHeader = exports.checkoutCookieOptions = exports.BASKET_COOKIE_NAME = exports.ORDER_REFERENCE_COOKIE_NAME = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
exports.ORDER_REFERENCE_COOKIE_NAME = 'orderReference';
exports.BASKET_COOKIE_NAME = 'basketId';
// A browser refuses a SameSite=Lax cookie in the cross-site frame a partner site uses, so these
// use CHIPS. Partitioned and SameSite=None both need Secure, which local http cannot offer.
const checkoutCookieOptions = ({ isSecure, }) => ({
    path: '/',
    secure: isSecure,
    sameSite: isSecure ? 'none' : 'lax',
    partitioned: isSecure,
});
exports.checkoutCookieOptions = checkoutCookieOptions;
const isSecureContext = process.env.NODE_ENV === 'production';
const cookieOptions = (0, exports.checkoutCookieOptions)({ isSecure: isSecureContext });
// js-cookie writes document.cookie, so a server response needs its own serialiser.
const checkoutCookieHeader = ({ name, value, isSecure, }) => {
    const options = (0, exports.checkoutCookieOptions)({ isSecure });
    const parts = [`${name}=${value}`, `Path=${options.path}`];
    if (options.secure) {
        parts.push('Secure');
    }
    parts.push(options.sameSite === 'none' ? 'SameSite=None' : 'SameSite=Lax');
    if (options.partitioned) {
        parts.push('Partitioned');
    }
    return parts.join('; ');
};
exports.checkoutCookieHeader = checkoutCookieHeader;
const setOrderReferenceCookie = (orderReference) => {
    js_cookie_1.default.set(exports.ORDER_REFERENCE_COOKIE_NAME, orderReference, cookieOptions);
};
exports.setOrderReferenceCookie = setOrderReferenceCookie;
const getOrderReferenceCookie = () => {
    return js_cookie_1.default.get(exports.ORDER_REFERENCE_COOKIE_NAME);
};
exports.getOrderReferenceCookie = getOrderReferenceCookie;
// A delete only matches a partitioned cookie when it repeats the same attributes.
const removeOrderReferenceCookie = () => {
    js_cookie_1.default.remove(exports.ORDER_REFERENCE_COOKIE_NAME, cookieOptions);
};
exports.removeOrderReferenceCookie = removeOrderReferenceCookie;
const setBasketCookie = (basketId) => {
    js_cookie_1.default.set(exports.BASKET_COOKIE_NAME, basketId, cookieOptions);
};
exports.setBasketCookie = setBasketCookie;
const getBasketCookie = () => {
    return js_cookie_1.default.get(exports.BASKET_COOKIE_NAME);
};
exports.getBasketCookie = getBasketCookie;
const removeBasketCookie = () => {
    js_cookie_1.default.remove(exports.BASKET_COOKIE_NAME, cookieOptions);
};
exports.removeBasketCookie = removeBasketCookie;
const basketCookieHeader = (basketId) => (0, exports.checkoutCookieHeader)({
    name: exports.BASKET_COOKIE_NAME,
    value: basketId,
    isSecure: isSecureContext,
});
exports.basketCookieHeader = basketCookieHeader;
exports.AFFILIATE_COOKIE_NAME = 'affiliate';
const getAffiliateCookie = () => {
    return js_cookie_1.default.get(exports.AFFILIATE_COOKIE_NAME);
};
exports.getAffiliateCookie = getAffiliateCookie;
